import type { TemplateDto } from '@pb/shared';
import { get, post, uploadFile } from './client';

export const getTemplate = (projectId: number) => get<TemplateDto>(`/projects/${projectId}/template`);
export const uploadTemplateVersion = (
  projectId: number,
  file: File,
  note: string,
  onProgress: (fraction: number) => void,
) => uploadFile<unknown>(`/projects/${projectId}/template`, file, { note: note.trim() || undefined }, onProgress);
export const copyTemplate = (projectId: number, targetProjectId: number) =>
  post<unknown>(`/projects/${projectId}/template/copy`, { target_project_id: targetProjectId });
export const templateVersionFileUrl = (id: number) => `/api/template-versions/${id}/file`;
